export const PageHeader = ({ overline, title, lede, align = "left" }) => {
  return (
    <section
      data-testid="page-header"
      className="border-b border-rule bg-linen-alt"
    >
      <div className={`max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-28 ${align === "center" ? "text-center" : ""}`}>
        {overline && (
          <div className="text-xs uppercase tracking-[0.22em] text-ember font-accent font-semibold">
            {overline}
          </div>
        )}
        <h1
          data-testid="page-header-title"
          className="font-serif font-light tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-ink mt-5 text-balance leading-[1.05] max-w-4xl"
        >
          {title}
        </h1>
        {lede && (
          <p className="mt-6 text-lg md:text-xl text-ink-muted leading-relaxed max-w-2xl font-light">
            {lede}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
